import { Box, styled } from '@mui/material';
var StyledRangeButtonsWrapper = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    marginBottom: theme.spacing(1.5)
  };
  return styles;
});
export { StyledRangeButtonsWrapper };